import cookie from 'webmd-cookie';
import debug from 'webmd-debug';
require("webmd-ad-kibana");
require("webmd-tug-eval-promise");

/*
 * Headerbidding integration for Medianet Prebid
 *
 */
if (typeof window !== 'undefined') {
  window.googletag = window.googletag || {};
  googletag.cmd = googletag.cmd || [];  


  // checks if headerbidding is diabled via mn=0 query parameter
  let disableHeaderbidding = function() {
    return ((/[?&]mn=0/).test(location.search) || window.location.href.indexOf('nobeacon') > -1 );
  };
  let assignVariation = function() {
    return Math.random() < 0.5 ? "mn" : "pb";
  };

  //check if magnite demand ab testing should be done 
  var magniteABTopics = new Set(['4301']);
  const isTopicMatch = window.s_topic && magniteABTopics.has(window.s_topic);
  if (isTopicMatch && !window.document.referrer.includes('medscape.com')){
    var abTest = assignVariation()//cookie.get('ab_124');
    if (abTest && abTest === 'pb') {
      window.prebidExperiment = true;
    } else if (abTest && abTest === 'mn') {
      window.prebidExperiment = false;
    }
  }

  var searchParams = new URLSearchParams(window.location.search);
	var ecdParam = '';
	var conmktParams = ["conmktmfb", "conmkttjg", "conmktmjg", "conmkt"];
	var isSlideShow = false;
  var vendorConfig;
	if (searchParams) {
		ecdParam = searchParams.get('ecd');
	}
	if (window.s_business_reference && (window.s_business_reference.toLowerCase().indexOf("slideshow") > -1 || window.s_business_reference.toLowerCase().indexOf("slide show") > -1)) {
		isSlideShow = true;
	}

	if(isSlideShow){
		for(var i=0; i<conmktParams.length; i++){
			if( ecdParam && ecdParam != '' && ecdParam.indexOf(conmktParams[i]) > -1){
				 vendorConfig = {
					twitter: { disable: true },
					reddit: { disable: true },
					pinterest: { disable: true },
					tiktok: { disable: true },
					outbrain: { disable: true },
					hotJar: { disable: true },
					amazon: { disable: true },
					medianet: { disable: true }
				};
				if(ecdParam && ecdParam != '' &&  ecdParam.indexOf("conmktmfb") > -1){
					vendorConfig.medianet.disable = false;
				}
				window.globalConfig = window.globalConfig || {};
				window.globalConfig.ads = window.globalConfig.ads || {};
				window.globalConfig.ads.vendorConfig = window.globalConfig.ads.vendorConfig || {};
				window.globalConfig.ads.vendorConfig = Object.assign(window.globalConfig.ads.vendorConfig, vendorConfig);
			}
		}
	}
    
  // load GPT library
  let loadGPT = function() {
    if (!window.advBidxc.isAdServerLoaded && !window.googleloaded) {
      let stdGPT = '//securepubads.g.doubleclick.net/tag/js/gpt.js';
      let ltdGPT = '//pagead2.googlesyndication.com/tag/js/gpt.js';
      
      if (window.advBidxc.limitedAds) {
        loadScript(ltdGPT);
      } else {
        loadScript(stdGPT);
      }
      
      window.googleloaded = true;
      window.advBidxc.isAdServerLoaded = true;
    }
  };

  // load a script tag
  let loadScript = function(tagSrc) {
    let 
    scriptTag = document.createElement('script'),
    placeTag = document.getElementsByTagName("script")[0];

    if (tagSrc.substr(0, 4) !== 'http') {
      let isSSL = true;
      tagSrc = (isSSL ? 'https:' : 'http:') + tagSrc;
    }

    scriptTag.type = 'text/javascript';
    scriptTag.src = tagSrc;
    scriptTag.async = true;
    placeTag.parentNode.insertBefore(scriptTag, placeTag);

    if (tagSrc.includes('bidexchange')) {
      /**
       * performance mark to spot when medianet code has started loading
       */
      try {
        window.performance.mark("medianet-load-start");
        window.performance.measure('measure-medianet-load-start', 'ads-code-load', 'medianet-load-start');
        debug('(Perf-Mark) Medianet load started -> ' + window.performance.getEntriesByName('measure-medianet-load-start', 'measure')[0].duration);

        scriptTag.onload = function () {
          /**
           * performance mark to spot when medianet code has loaded
           */
          window.performance.mark('medianet-loaded');
          window.performance.measure('measure-medianet-loaded', 'ads-code-load', 'medianet-loaded');
          debug('(Perf-Mark) Medianet loaded -> ' + window.performance.getEntriesByName('measure-medianet-loaded', 'measure')[0].duration);
        };
        scriptTag.onerror = function() {
          window.webmd.createBeaconCall("webmd-vendor-flow", "webmd-medianet", "webmd-medianet-load-failed");
          debug('medianet not loaded on error');
          reject();
        } 
      } catch (e) {
        debug(e)
      }
      
    }

  };

  let shouldRemoveAds = function()
    {
      // Check if the 'conmktvid' parameter is present in the URL
      if (typeof window !== 'undefined' && window.location && window.location.href) {
        return window.location.href.indexOf('conmktvid') > -1;
      }
    return false; // Return false if the checks fail
    };

  
  (function() {
     // Check if convmid or conmktvid parameter is present in the URL
     if (shouldRemoveAds()) {
      debug("Ads initialization skipped due to 'convmid' or 'conmktvid' parameter in URL.");
      return; // Skip the rest of the initialization if either parameter is present
    }
    //PPE-324582 : Disable Vendor
    //Disable vendor if url containts vendor=0 or medianetheaderbidding=0
    var url = (document.referrer) ? document.referrer : document.location.href;
    if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('mn=0') > -1)) {
      return false;
    }

    // Disable vendor based on ads admin tool data
    if(window.globalConfig && window.globalConfig.ads) {

      let vendorConfig = window.globalConfig.ads.vendorConfig;
      let medianetConfig = vendorConfig.medianet ? vendorConfig.medianet : {};
      let location = cookie.getJson('gtinfo');
			
      /**
       *  Gtinfo cookie stores country code in lowercase while admin tool db stores in uppercase
       *  hence text transform is done.
       */
      let isLocationAdded = false;
      let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
      let locationList = medianetConfig.location ? medianetConfig.location : [];
                                                                                                                                    
      /** 
       *  If the gtinfo is not available and only some of the locations are selelcted, 
       *  location based vendor suppression cannot be done properly. Hence, vendors can be loaded 
       *  as default behavior. 
       * 
       *  If location property is undefined or no countries are added in location array 
       *  or all the countries are selected, then it can be considered as 
       *  all the locations are selected and not required to check for gtinfo.
       *  Countries available in WebMD gtinfo file : 249
       */
      if ( !(countryCode == '' && locationList.length > 0 && locationList.length < 249) ) {
        if ( locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode) ) {
          isLocationAdded = true;
        }
        /**
         *  If disable is true and the location is included in the location array, 
         *  then vendor should not be loaded.   
         *  If disable is set to false and certain countries are added in location array, 
         *  then for the countries that are not added in the array can be considered 
         *  to have disable : true and vendor should not be loaded in this case. 
         */
        if (medianetConfig.disable && isLocationAdded) {
          return false;
        } else if ( !(medianetConfig.disable) && !isLocationAdded ) {
          return false;			
        }
      }
    }

    // if in iframe exit immediately;
    if (window.top !== window.self) {
      return;
    }

    // if we are on sensitive topic pages 
    if (window.s_sensitive && window.s_sensitive === "true") {
      return;
    }

    // if we are on fit, labs, member or webmdrx page, return immediately
    if ( (/member.|fit.|labs.|webmdrx\./).test(location.host)) {
      return;
    }

    // if we don't want biddings on some pages specifically additudemag
    if (window.webmd && window.webmd.adConfig && (window.webmd.adConfig.disableMediaNet || window.webmd.adConfig.disableVendors) ) {
      return
    }

    // if we are on a funded page, return immediately
    if (window.s_sponsor_brand && window.s_sponsor_brand.length > 0) {
      return;
    }
    var urlParams = new URLSearchParams(window.location.search);
    // check if Media.net's refresh is disabled via optiRefresh=true query parameter
    if(urlParams) {
      if (urlParams.get('optiRefresh') === 'true') {
        return;
      }
    }
    var mnetAb = urlParams.get('force_tscode');
    var pageTopic = window.s_topic || "";

    // load media.net header-bidding
    window.advBidxc = window.advBidxc || {};
    window.advBidxc.startTime = new Date().getTime();
    window.advBidxc.timeout = 300;
    window.advBidxc.version = 12.1;
    window.advBidxc.customerId = "8CURKHUZE"; //Media.net HB 2.0 Customer ID
    window.advBidxc.domain = window.location.hostname;
    window.advBidxc.limitedAds = false;
    window.advBidxc.renderAd = function () {};
    
    var mnTgts = { 
      section: pageTopic, //Publisher’s section on the site, eg. page topic value 
      site: "webmd" //Publisher’s site, eg. webmd
    };
    window.advBidxc.pub = mnTgts;

    // Enable only medianet refresh for below topics and referrer should not be medscape.com
    // let topics = ['4289', '4301', '2951', '3561', '3564', '4270', '3642', '1836', '1830']; 
    if (typeof window.prebidExperiment !== 'undefined' && window.prebidExperiment && !window.document.referrer.includes('medscape.com') ) {
      window.advBidxc.version = 12.1;
      window.advBidxc.customerId = "8CU723318";
    }


    // Enable only medianet refresh for Care profile pages based on specialty
    if (window.location.href.includes('/doctor/')) {
      const blockSpecialtyIds = new Set(['29285', '29313', '29326', '29245', '29261']);
      let initialState = window.__INITIAL_STATE__;
      if ( initialState && initialState.profile && initialState.profile.specialites ) {
        let specialties = initialState.profile.specialites;
        const hasBlockedSpecialty = specialties.some(({ Id }) => blockSpecialtyIds.has(Id));
        if (hasBlockedSpecialty) {
           window.advBidxc.version = 12.1;
           window.advBidxc.customerId = "8CU723318";
        }
      } 
    }

    if (!window.s_contains_video && !disableHeaderbidding()) {
        /**
         * we need to load MNET once __tcfapiPromise is resolved,
         * the Promise is resolved once tcfapi.js is loaded onto the page
         * 
         * tcfapi.js is loaded only in EU locations and in other locations the Promise is
         * resolved immediately (handled in IAB stub code - webmd-ccm.js)
         * 
         * Ref: https://jira.internetbrands.com/browse/PPE-279145
        */
        Promise.resolve(window.__tcfapiPromise).then(function () {
          var mnSrc = `//hbx.media.net/bidexchange.js?cid=${window.advBidxc.customerId}&version=${window.advBidxc.version}&dn=${window.advBidxc.domain}&ysite=${encodeURIComponent(mnTgts.site)}&ysection=${encodeURIComponent(mnTgts.section)}`; 
            
          if(mnetAb){
             mnSrc += `&force_tscode=${mnetAb}`;
					}
          loadGPT();
          if (window.top === window.self) {
            // Load id5 api first and then load medianet so that medianet can pick id5userid
            if(window.webmd.id5){
              Promise.resolve(window.webmd.id5.loadId5Promise).then(function() {
                Promise.resolve(window.tugEvalPromise).then(function(sponsor){
                  if(sponsor){
                    return;
                  }else{
                    loadScript(mnSrc)
                  }
                });
              });
            }else{
              Promise.resolve(window.tugEvalPromise).then(function(sponsor){
                if(sponsor){
                  return;
                }else{
                  loadScript(mnSrc)
                }
              });
            }
          }
        });
    }
  })();
}
